import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { usePopularDocuments } from '../../hooks/useDocuments';

import onboardingItems from '../../data/pro_onboarding';
import ProOnboardingCard from '../cards/ProOnboardingCard';
import RowList from '../lists/RowList';

import styles from '../../styles/partials/pro-onboarding.module.css';

interface ProOnboardingProps {
    className?: string;
    itemsClassName?: string;
}

function ProOnboarding({ className, itemsClassName }: ProOnboardingProps) {
    const { items: popularDocuments = null } = usePopularDocuments({ count: 12 });
    const [selectedPopularDocument, setSelectedPopularDocument] = useState(null);
    useEffect(() => {
        if (popularDocuments !== null && popularDocuments.length > 0) {
            setSelectedPopularDocument(
                popularDocuments[Math.floor(Math.random() * popularDocuments.length)],
            );
        }
    }, [popularDocuments]);
    const selectDocument = (id) => {
        const document = popularDocuments.find((doc) => doc.id === id);
        if (document !== undefined) {
            setSelectedPopularDocument(document);
        }
    };
    return (
        <RowList
            items={onboardingItems}
            cardComponent={ProOnboardingCard}
            cardProps={{ popularDocuments, selectedPopularDocument, selectDocument }}
            className={classNames([styles.container, className])}
            itemsClassName={classNames([styles.items, itemsClassName])}
        />
    );
}

export default ProOnboarding;
